import { RbacFeature, RbacFeatureDetails, RbacApiPermission } from '@evidentid/tprm-portal-lib/models/rbac';

type DecisioningFeatures = Extract<RbacFeature,
    | RbacFeature.decisioningViewRiskProfiles
    | RbacFeature.decisioningViewRiskProfile
    | RbacFeature.decisioningViewEntitiesAssigned
    | RbacFeature.decisioningCreateRiskProfile
    | RbacFeature.decisioningEditRiskProfile
    | RbacFeature.decisioningDeleteRiskProfile
    | RbacFeature.decisioningManageRiskRequirements
    | RbacFeature.decisioningManageCriteria
    | RbacFeature.decisioningManageEvaluationRules
    | RbacFeature.decisioningManageAssignmentRules
    | RbacFeature.decisioningSaveRiskProfileChanges
>;

export const DECISIONING_FEATURE_PERMISSIONS_MAP: Record<DecisioningFeatures, RbacFeatureDetails> = {
    [RbacFeature.decisioningViewRiskProfiles]: {
        name: RbacFeature.decisioningViewRiskProfiles,
        label: 'View the risk profiles on the decisioning page',
        requiredPermissions: [
            RbacApiPermission.riskProfileGet,
        ],
    },
    [RbacFeature.decisioningViewRiskProfile]: {
        name: RbacFeature.decisioningViewRiskProfile,
        label: 'View a risk profile',
        requiredPermissions: [
            RbacApiPermission.riskProfileGet,
        ],
    },
    [RbacFeature.decisioningViewEntitiesAssigned]: {
        name: RbacFeature.decisioningViewEntitiesAssigned,
        label: 'View the entities assigned to a risk profile',
        requiredPermissions: [
            RbacApiPermission.entityGetRiskProfiles,
        ],
    },
    [RbacFeature.decisioningCreateRiskProfile]: {
        name: RbacFeature.decisioningCreateRiskProfile,
        label: 'Add a new risk profile',
        requiredPermissions: [
            RbacApiPermission.riskProfilePost,
        ],
    },
    [RbacFeature.decisioningEditRiskProfile]: {
        name: RbacFeature.decisioningEditRiskProfile,
        label: 'Edit a risk profile',
        requiredPermissions: [
            RbacApiPermission.riskProfilePut,
            RbacApiPermission.riskProfilePost,
        ],
    },
    [RbacFeature.decisioningDeleteRiskProfile]: {
        name: RbacFeature.decisioningDeleteRiskProfile,
        label: 'Delete a risk profile',
        requiredPermissions: [
            RbacApiPermission.riskProfileDelete,
        ],
    },
    [RbacFeature.decisioningManageRiskRequirements]: {
        name: RbacFeature.decisioningManageRiskRequirements,
        label: 'Add, edit, or remove risk requirements',
        requiredPermissions: [
            RbacApiPermission.riskCriteriaPatch,
            RbacApiPermission.riskCriteriaPost,
        ],
    },
    [RbacFeature.decisioningManageCriteria]: {
        name: RbacFeature.decisioningManageCriteria,
        label: 'Add, edit, or remove criteria',
        requiredPermissions: [
            RbacApiPermission.riskCriteriaPost,
            RbacApiPermission.riskCriteriaPatch,
        ],
    },
    [RbacFeature.decisioningManageEvaluationRules]: {
        name: RbacFeature.decisioningManageEvaluationRules,
        label: 'Add, edit, or remove evaluation rules',
        requiredPermissions: [
            RbacApiPermission.riskProfilePut,
            RbacApiPermission.riskProfilePost,
        ],
    },
    [RbacFeature.decisioningManageAssignmentRules]: {
        name: RbacFeature.decisioningManageAssignmentRules,
        label: 'Add, edit, or remove assignment rules',
        requiredPermissions: [
            RbacApiPermission.riskProfilePut,
            RbacApiPermission.riskProfilePost,
        ],
    },
    [RbacFeature.decisioningSaveRiskProfileChanges]: {
        name: RbacFeature.decisioningSaveRiskProfileChanges,
        label: 'Save changes to a risk profile',
        requiredPermissions: [
            RbacApiPermission.riskProfilePut,
            RbacApiPermission.riskProfilePost,
            RbacApiPermission.riskCriteriaPost,
            RbacApiPermission.riskCriteriaPatch,
        ],
    },
};
